<template>
    <div>
        <div :class="{ 'modal-caption': true, 'ml-5 mr-5': !!(desktop || largeDesktop) }">
            При загрузке нескольких файлов поля для Поручения заполняются из первой ДТ, сведения в товарной части - из всех ДТ.
        </div>
        <b-alert variant="danger" show v-if="maxFileSize > 0" :class="{ 'file-size-error': true, 'ml-5 mr-5': !!(desktop || largeDesktop) }">
            Ошибка загрузки файла! Максимальный размер <b>10Мб</b>.
        </b-alert>
        <b-alert variant="danger" show v-if="!isXml" :class="{ 'file-size-error': true, 'ml-5 mr-5': !!(desktop || largeDesktop) }">
            Ошибка загрузки файла! Допустимый формат <b>XML</b>
        </b-alert>
        <div class="example-drag">
            <div class="upload">
                <div :class="{ 'up-edit-files-wrapper': true, 'mb-3 mr-5 ml-5': !!(desktop || largeDesktop) }" :style="addBorderStyle()">
                    <div class="attachments-wrapper">
                        <div v-for="file in uploadedFiles"
                             :key="file.id"
                             class="up-attachment"
                             @click="downloadFile($event, file)"
                             :style="({ width: (desktop || largeDesktop) ? (attachmentWidth) : '266px'})">
                            <div class="attachment-inner-container">
                                <div class="file-icon-wrapper">
                                    <font-awesome-icon :icon="file.icon" class="file-icon" />
                                    <div class="remove-file-button"
                                         :id="file.id"
                                         @click="removeFile($event, file)">
                                        <font-awesome-icon icon="times-circle" :style="{ color: '#e7161a', fontSize: '21px' }" />
                                    </div>
                                </div>
                                <div class="attachment-name-wrapper">
                                    <div class="mb-5 mr-4">{{ file.name }}</div>
                                    <span :class="{ 'badge': true, 'file-size': true, 'badge-danger': (file.size >= 1024*1024*10), 'badge-secondary': (file.size < 1024*1024*10) }">
                                        {{calcFileSize(file.size)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <file-upload id="file-upload"
                                     :drop="true"
                                     :drop-directory="true"
                                     :class="{ 'ml-5 mr-5': !!(desktop || largeDesktop) }"
                                     :multiple="true"
                                     :value="uploadedFiles"
                                     @input="inputUpdate"
                                     @input-file="inputFiles"
                                     accept="text/xml">
                            <div class="text-center p-5" v-show="!uploadedFiles.length">
                                <div v-if="mobile || tablet">
                                    <h5 class="upload-caption-header">Загрузить файлы</h5>
                                    <div class="upload-caption">Поддерживается формат XML.</div>
                                    <div class="upload-caption">Максимальный размер файла - 10 Мб.</div>
                                </div>
                                <div v-if="desktop || largeDesktop">
                                    <h5 class="upload-caption-header">Перетащите файлы документов в это окно</h5>
                                    <div class="upload-caption mb-2">Или кликните, чтобы загрузить их с компьютера</div>
                                    <div class="upload-caption">Документы должны быть в формате XML</div>
                                    <div class="upload-caption">Максимальный размер файла - 10 Мб.</div>
                                </div>
                            </div>
                        </file-upload>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
              <b-button 
                squared  
                variant="danger" 
                @click="handleCancel"
                class="modal-form-action-buttons mr-5"
                size="sm"
                :disabled="loading">Отмена
              </b-button>
              <b-button 
                squared 
                :variant="(!uploadedFiles.length || maxFileSize>0 || !isXml) ? 'secondary' : 'success'"
                :disabled="(!uploadedFiles.length || maxFileSize>0 || !isXml || loading)"
                @click="sendFiles"
                size="sm"
                class="modal-form-action-buttons">
                  Загрузить
                  <b-spinner 
                    v-show="loading" 
                    small 
                    label="Loading..." 
                    style="vertical-align:sub;" />
              </b-button>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import FileUpload from 'vue-upload-component'
  import arrOfIcons from '../json/arr_of_icons.json'
  export default {
    name: "FileUploadForm",
    components: {
      FileUpload
    },
    props: [ 'loading' ],
    data () {
      return {
        attachmentWidth: '30%',
        maxFileSize: 0,
        uploadedFiles: [],
        isXml: true
      }
    },
    computed: {
      ...mapState(
        {
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop,
        }
      )
    },
    methods: {
      inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
        if (!/\.(xml)$/i.test(newFile.name)) {
          return prevent()
        }
            }

      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },
    sendFiles() {
        this.$emit('loadFiles', this.uploadedFiles)
    },
      handleCancel() {
        this.$root.$emit('bv::hide::modal', 'modalLoadFiles', event)
      },
      removeFile (event, file) {
        event.stopPropagation()
        if (file.size > 1024 * 1024 * 10)
        {
          this.maxFileSize--
        }
        const index = this.uploadedFiles.indexOf(file)
        if (index > -1) this.uploadedFiles.splice(index, 1)
        this.isXml = this.hasOnlyXmlFiles()
      },
      inputUpdate (value) {
        for (let q = 0; q < value.length; q++) {
          value[q].icon = ''
          let ext = this.getFileExt(value[q].name)
          for (const key in arrOfIcons) {
            if (ext.toLowerCase().indexOf(key) !== -1) {
              value[q].icon = arrOfIcons[key]
              break
            }
          }
          if (!value[q].icon) {
            value[q].icon = 'fas fa-file'
          }
        }

        this.uploadedFiles = value
        this.isXml = this.hasOnlyXmlFiles()
      },
      inputFiles (newFile, oldFile) {
        if (newFile && !oldFile) {
          if (newFile.size > 1024 * 1024 * 10) {
            this.maxFileSize++
          }
        }
        if (!newFile && oldFile) {
          if (oldFile.size > 1024 * 1024 * 10) {
            this.maxFileSize--
          }
        }
      },
      addBorderStyle () {
        if (this.mobile || this.tablet) {
          return { border: this.maxFileSize > 0 ? '1px solid #e7161a !important' : '1px solid #cfd8dc !important' }
        }
        if (this.desktop || this.largeDesktop) {
          return { border: this.maxFileSize > 0 ? '2px solid #e7161a !important' : '2px solid #cfd8dc !important' }
        }
      },
      calcFileSize (FileSize) {
        const FileSizeInKb = Math.floor(FileSize / 1024)
        let FileSizeInMb = 0
        let FileSizeInGb = 0
        if (FileSizeInKb > 0) {
          FileSizeInMb = Math.floor(FileSizeInKb / 1024)
          if (FileSizeInMb > 0) {
            FileSizeInGb = Math.floor(FileSizeInMb / 1024)
            if (FileSizeInGb > 0) {
              return FileSizeInGb + ' Гб'
            } else {
              return FileSizeInMb + ' Мб'
            }
          } else {
            return FileSizeInKb + ' Кб'
          }
        } else {
          return FileSize + ' байт'
        }
        },
      hasOnlyXmlFiles() 
      {
        let result = true;
        for (let q = 0; q < this.uploadedFiles.length; q++)
        {
            const file = this.uploadedFiles[q]
            let ext = this.getFileExt(file.name)
            if (ext.toLowerCase() !== 'xml') result = false;
        }
        return result;
      },
      getFileExt(fileName)
      {
        let ext = ''
        const parts = fileName.split('.')
        if (parts.length > 1) ext = parts.pop()
        return ext
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .upload-caption {
      font-size: 12px;
    }
  }
  .modal-caption {
    font-size: 16px;
    color: #37474F;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  .up-edit-files-wrapper {
    position: relative;
    .attachments-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      .up-attachment {
        margin-bottom: 16px;
        padding: 10px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: relative;
        z-index: 1;
        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
        @extend .attachment-inner-container;
      }
      @media screen and (min-width: 1024px) {
        .up-attachment {
          margin-right: 16px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .attachments-wrapper {
        justify-content: center;
        margin-top: 0.75rem;
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .up-edit-files-wrapper {
      min-height: 110px;
      margin-bottom: 0.75rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .up-edit-files-wrapper {
      padding-top: 16px;
      padding-left: 16px;
      min-height: 200px;
    }
  }

  .attachment-inner-container {
    display: flex;
    width: 100%;
    word-break: break-all;
    .file-icon-wrapper {
      margin-right: 10px;
      svg {
        font-size: 32px;
        color: #78909C;
      }
      .remove-file-button {
        position: absolute;
        top: 5px;
        right: 5px;
        svg {
          color: #E7161A;
          font-size: 21px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .file-icon-wrapper {
        width: 32px;
        min-width: 32px;
      }
    }
    .attachment-name-wrapper {
      font-size: 14px;
      letter-spacing: 0.25px;
      line-height: 20px;
      color: #37474F;
      .max-file-size-error {
        color: #ad1013;
        font-size: 14px;
        position: absolute;
        left: 10px;
        bottom: 8px;
        font-weight: bold;
      }
      .file-size {
        position: absolute;
        right: 10px;
        bottom: 10px;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  .example-drag {
    label.btn {
      margin-bottom: 0;
      margin-right: 1rem;
    }
    .drop-active {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 2;
      opacity: .6;
      text-align: center;
      background: #000;
      border-radius: 0.3rem;
      outline: 0;
      h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
      }
    }
    .file-uploads {
      z-index: 0;
      position: absolute !important;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
    @media screen and (min-width: 1024px) {
      .file-uploads {
        width: calc(100% - 40px);
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .example-drag {
      text-align: center;
    }
  }

  h5 {
    font-weight: normal !important;
  }
</style>
